import { BRANDS, resolveBrandId, type Brand, type BrandId } from "./brands";

export { BRANDS, resolveBrandId };
export type { Brand, BrandId };

function pickBrand(): Brand {
  // En développement le nom d'hôte est localhost, donc Inspexio. `DR_BRAND=dr`
  // (cf. `npm run start:dr`) force l'ancienne marque, pour voir ce que voient
  // les utilisateurs restés sur diagnosticrapid.fr — bandeau de migration
  // compris.
  const forced = import.meta.env.DR_BRAND;
  if (forced && forced in BRANDS) return BRANDS[forced as BrandId];

  return BRANDS[resolveBrandId(window.location.hostname)];
}

/**
 * La marque servie par le domaine courant. Résolue une fois au chargement :
 * elle ne peut pas changer sans quitter l'origine.
 */
export const currentBrand: Brand = pickBrand();

/**
 * Icône carrée de l'app (marque sur fond plein), telle qu'elle apparaîtra sur
 * l'écran d'accueil. Sert à illustrer la proposition d'installation : on montre
 * exactement ce que l'utilisateur va obtenir.
 */
export const currentBrandAppIcon: string =
  currentBrand.icons.find((icon) => icon.sizes === "192x192")?.src ??
  currentBrand.icons[0].src;
